import { chatDrawerSelectors } from 'ducks/chatDrawer'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getMatchingSuggestions } from '../messageSuggestions'
import { getSelectedSystem, isEditorReady } from '../utils/validateActionRequirements'

export const useMessageSuggestions = (): string[] => {
  const location = useLocation()
  const [refreshKey, setRefreshKey] = useState(0)
  const chatDrawerOpen = useSelector(chatDrawerSelectors.getChatDrawerOpen)
  const prevChatDrawerOpenRef = useRef(chatDrawerOpen)

  useEffect(() => {
    if (chatDrawerOpen && !prevChatDrawerOpenRef.current) {
      setRefreshKey((prev) => prev + 1)
    }
    prevChatDrawerOpenRef.current = chatDrawerOpen
  }, [chatDrawerOpen])

  const suggestions = useMemo(() => {
    const pathname = location.pathname
    const isStudioLoaded = isEditorReady()
    const selectedSystem = getSelectedSystem()
    const hasSelectedSystem = selectedSystem !== null

    return getMatchingSuggestions(pathname, isStudioLoaded, hasSelectedSystem, selectedSystem)
  }, [location.pathname, refreshKey])

  return suggestions
}
